/* eslint-disable global-require */
const axios = require('axios')

module.exports.listAdmins = async acessToken => {
  const attendentsList = await axios.get('https://app.manyconvert.com/api/user/admin/list', {
    headers: {
      Authorization: `Bearer ${acessToken}`,
    },
  }).then(resp => resp.data)

  console.log(attendentsList)
  return attendentsList
}

module.exports.deleteAtendente = async attendenteId => {
  const userData = JSON.parse(localStorage.getItem('userData'))

  const attendentsList = await axios.delete(`https://app.manyconvert.com/api/attendants?id=${attendenteId}`, {
    headers: {
      Authorization: `Bearer ${userData.mc_access_token}`,
    },
  }).then(resp => resp.data)

  console.log(attendentsList)
  return attendentsList
}
